import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MsgNetLoading from '../components/MsgNetLoading';
import CompeticionList from '../components/CompeticionList';
import TopHeaderMenu from '../components/TopHeaderMenu';
import IconMap from '../icons/IconMap';
import CONFIG from '../config';

class EventoDetailScreenClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      competiciones: [],
      isLoading: true,
      evento: null,
    };
  }

  onClickBack() {
    this.props.navigate('/');
  }

  componentDidMount() {
    const eventoId = parseInt(this.props.params.eventoId, 10);
    if (!eventoId || isNaN(eventoId)) {
      this.setState({ isLoading: false, evento: null });
      return;
    }
    this._eventoId = eventoId;
    this._unmounted = false;
    this.fetchEvento();
    this._connectWS();
  }

  fetchEvento() {
    fetch(`${CONFIG.API_URL}/api/1.0/live/evento/${this._eventoId}/`)
      .then(r => r.json())
      .then(data => {
        this.setState({
          evento: data.evento,
          competiciones: data.competiciones,
          isLoading: false,
        });
      })
      .catch(err => {
        console.error('live-evento error:', err);
        this.setState({ isLoading: false });
      });
  }

  _connectWS() {
    if (this._unmounted) return;
    const ws = new WebSocket(`${CONFIG.WS_URL}/ws/0`);
    this._ws = ws;
    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        if (msg.tipo === 'eventos_update') this.fetchEvento();
      } catch (_) {}
    };
    ws.onclose = () => {
      this._ws = null;
      if (!this._unmounted) setTimeout(() => this._connectWS(), 2000);
    };
    ws.onerror = () => ws.close();
  }

  componentWillUnmount() {
    this._unmounted = true;
    if (this._ws) { this._ws.close(); this._ws = null; }
  }

  render() {
    const { evento, competiciones, isLoading } = this.state;

    return (
      <div>
        <TopHeaderMenu competicion={evento} onClickBack={this.onClickBack.bind(this)} />
        {isLoading ? (
          <MsgNetLoading />
        ) : (evento && evento.visible) ? (
          competiciones && competiciones.length ? (
            <div className="px-5 py-6 max-w-4xl mx-auto">
              <CompeticionList competiciones={competiciones} eventoNombre={evento?.nombre} />
              {evento.url_recorridos && (
                <div className="mt-8 bg-gray-800 rounded-lg p-4 border border-gray-700">
                  <a href={evento.url_recorridos} target="_blank" rel="noopener noreferrer"
                    className="flex items-center justify-between text-gray-300 hover:text-white transition-colors group">
                    <div className="flex items-center gap-3">
                      <IconMap className="w-6 h-6 text-white" />
                      <span className="font-light font-montserrat text-white">Ver recorridos del evento ↗</span>
                    </div>
                  </a>
                </div>
              )}
            </div>
          ) : (
            <div className="px-5 py-6 max-w-4xl mx-auto text-center">
              <h3 className="text-xl text-gray-300 mt-12">No existen competiciones activas</h3>
            </div>
          )
        ) : (
          <div className="px-5 py-6 max-w-4xl mx-auto text-center font-montserrat">
            <h2 className="text-xl font-light text-gray-300 mt-12 mb-6">No se ha podido encontrar el evento</h2>
            <button onClick={() => this.props.navigate('/')}
              className="px-6 py-2 bg-ccnorte hover:bg-red-500 text-white rounded-lg font-montserrat text-sm transition-colors">
              Ir al inicio
            </button>
          </div>
        )}
      </div>
    );
  }
}

function EventoDetailScreen() {
  const navigate = useNavigate();
  const params = useParams();
  return <EventoDetailScreenClass navigate={navigate} params={params} />;
}

export default EventoDetailScreen;
